import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shortNumber'
})
export class ShortNumberPipe implements PipeTransform {
    transform(value: number, isCurrency): string {
        if (!value) return '0';

        let formattedValue: string;

        if (value >= 1_000_000) {
            formattedValue = (value / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
        } else if (value >= 1_000) {
            formattedValue = (value / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
        } else {
            formattedValue = value.toString();
        }

        return isCurrency ? `$${formattedValue}` : formattedValue;
    }
}